(function () {
  'use strict';

  // Mobile menu — portal to body (header backdrop-filter breaks fixed inset),
  // touch-safe toggle, Escape, focus return, body lock
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var header = document.querySelector('.site-header');

  function syncNavTop() {
    if (!mobileNav) return;
    var h = header ? header.getBoundingClientRect().bottom : 0;
    // When portaled to body, top is viewport-relative
    var top = Math.max(0, h);
    mobileNav.style.top = top + 'px';
    mobileNav.style.bottom = '0px';
    mobileNav.style.left = '0px';
    mobileNav.style.right = '0px';
    // Fit visual viewport (Safari chrome)
    var vv = window.visualViewport;
    if (vv) {
      var fromBottom = Math.max(0, window.innerHeight - (vv.offsetTop + vv.height));
      mobileNav.style.bottom = fromBottom + 'px';
      mobileNav.style.maxHeight = Math.max(200, vv.height - top + vv.offsetTop) + 'px';
    } else {
      mobileNav.style.maxHeight = '';
    }
  }

  function closeMobileNav() {
    if (!mobileNav || !toggle) return;
    mobileNav.classList.remove('is-open');
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    mobileNav.setAttribute('aria-hidden', 'true');
  }

  function openMobileNav() {
    if (!mobileNav || !toggle) return;
    // Escape header containing-block (backdrop-filter / sticky)
    if (mobileNav.parentElement !== document.body) {
      document.body.appendChild(mobileNav);
    }
    mobileNav.classList.add('is-open');
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    syncNavTop();
    var first = mobileNav.querySelector('a, button');
    if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 20);
  }

  function toggleMobileNav(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!mobileNav || !toggle) return;
    if (mobileNav.classList.contains('is-open')) {
      closeMobileNav();
      try { toggle.focus(); } catch (err) {}
    } else {
      openMobileNav();
    }
  }

  if (toggle && mobileNav) {
    if (!mobileNav.id) mobileNav.id = 'hg-mobile-nav';
    toggle.setAttribute('aria-controls', mobileNav.id);
    toggle.setAttribute('aria-haspopup', 'true');
    mobileNav.setAttribute('aria-hidden', 'true');

    // Portal early so first open isn't clipped
    if (mobileNav.parentElement !== document.body) {
      document.body.appendChild(mobileNav);
    }
    syncNavTop();

    toggle.addEventListener('click', toggleMobileNav);
    // Make inner spans ignore pointer so the button always receives the hit
    toggle.querySelectorAll('span').forEach(function (s) {
      s.style.pointerEvents = 'none';
    });

    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        closeMobileNav();
      });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900) closeMobileNav();
      else if (mobileNav.classList.contains('is-open')) syncNavTop();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (mobileNav.classList.contains('is-open')) syncNavTop();
      });
      window.visualViewport.addEventListener('scroll', function () {
        if (mobileNav.classList.contains('is-open')) syncNavTop();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMobileNav();
        try { toggle.focus(); } catch (err) {}
        return;
      }
      // Simple focus trap while open
      if (e.key !== 'Tab' || !mobileNav.classList.contains('is-open')) return;
      var focusables = mobileNav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      focusables = Array.prototype.filter.call(focusables, function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  // Sticky header shrink + blur on scroll
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 24) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Scroll-triggered reveals (stagger siblings) — skip when reduced motion
  var reveals = document.querySelectorAll('.reveal');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); el.style.opacity = '1'; el.style.transform = 'none'; });
  } else if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay');
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    reveals.forEach(function (el, i) {
      if (!el.getAttribute('data-reveal-delay')) {
        var siblings = el.parentElement ? el.parentElement.querySelectorAll(':scope > .reveal') : [];
        if (siblings.length > 1) {
          var idx = Array.prototype.indexOf.call(siblings, el);
          if (idx > 0) el.setAttribute('data-reveal-delay', String(idx * 80));
        }
      }
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Hero subtle parallax / mesh drift
  var hero = document.querySelector('.hero');
  var mesh = document.querySelector('.hero__mesh');
  if (hero && mesh && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', function () {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var y = Math.min(40, Math.max(-20, -rect.top * 0.12));
      mesh.style.transform = 'translate3d(0,' + y + 'px,0)';
    }, { passive: true });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    var wrap = input.closest('[data-qty]');
    if (!wrap) return;
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    }
  });
})();

  // Category tiles: no click-to-open pictures (icon+label hover color in CSS)
  // Industry category tiles → modal carousel (disabled unless [data-industry-open] present)
  (function initIndustryCarousel() {
    var modal = document.querySelector('[data-industry-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('[data-industry-dialog]');
    var titleEl = modal.querySelector('[data-industry-title]');
    var track = modal.querySelector('[data-industry-track]');
    var dotsWrap = modal.querySelector('[data-industry-dots]');
    var openers = document.querySelectorAll('[data-industry-open]');
    if (!openers.length) return; // no clickable category pictures
    var index = 0;
    var slides = [];
    var lastFocus = null;

    function build(urls, label) {
      slides = urls.filter(Boolean);
      index = 0;
      if (titleEl) titleEl.textContent = label || 'In use';
      track.innerHTML = '';
      dotsWrap.innerHTML = '';
      slides.forEach(function (url, i) {
        var slide = document.createElement('div');
        slide.className = 'industry-carousel__slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
        var img = document.createElement('img');
        img.src = url;
        img.alt = (label || 'Category') + ' — glove use photo ' + (i + 1);
        img.width = 1280;
        img.height = 720;
        img.decoding = 'async';
        slide.appendChild(img);
        track.appendChild(slide);

        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'industry-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Show image ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(dot);
      });
      go(0);
    }

    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      var dots = dotsWrap.querySelectorAll('.industry-carousel__dot');
      dots.forEach(function (d, di) {
        d.setAttribute('aria-selected', di === index ? 'true' : 'false');
      });
    }

    function open(btn) {
      var label = btn.getAttribute('data-industry-label') || '';
      var raw = btn.getAttribute('data-industry-slides') || '';
      var urls = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!urls.length) return;
      lastFocus = btn;
      build(urls, label);
      modal.hidden = false;
      document.body.classList.add('industry-modal-open');
      if (dialog) dialog.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('industry-modal-open');
      track.innerHTML = '';
      dotsWrap.innerHTML = '';
      slides = [];
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn); });
    });
    modal.querySelectorAll('[data-industry-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    var prev = modal.querySelector('[data-industry-prev]');
    var next = modal.querySelector('[data-industry-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(index - 1);
      if (e.key === 'ArrowRight') go(index + 1);
    });

    // Touch swipe
    var startX = null;
    track.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX == null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      if (dx > 0) go(index - 1); else go(index + 1);
    }, { passive: true });
  })();


/* Wholesale form helpers */
(function () {
  var form = document.getElementById('WholesaleForm');
  if (!form) return;

  var wizard = form.querySelector('[data-wholesale-wizard]');
  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-wholesale-step]'));
  var indicators = Array.prototype.slice.call(form.querySelectorAll('[data-step-indicator]'));
  var statusEl = form.querySelector('[data-wholesale-step-status]');
  var errorEl = form.querySelector('[data-wholesale-step-error]');
  var backBtn = form.querySelector('[data-wholesale-back]');
  var nextBtn = form.querySelector('[data-wholesale-next]');
  var submitBtn = form.querySelector('[data-wholesale-submit]');
  var reviewEl = form.querySelector('[data-wholesale-review]');
  var casesInput = form.querySelector('#Wholesale-Cases');
  var casesHint = form.querySelector('#Wholesale-Cases-Hint');
  var pathRadios = form.querySelectorAll('[data-wholesale-quote-path]');
  var current = 1;
  var total = steps.length || 5;
  var stepNames = { 1: 'Contact', 2: 'Shipping', 3: 'Order', 4: 'Business', 5: 'Review' };

  function selectedQuotePath() {
    var checked = form.querySelector('[data-wholesale-quote-path]:checked');
    return checked ? checked.getAttribute('data-wholesale-quote-path') : '';
  }

  function syncCasesConstraints() {
    if (!casesInput) return;
    var path = selectedQuotePath();
    if (path === 'under48') {
      casesInput.min = '1';
      casesInput.required = true;
      casesInput.placeholder = 'e.g. 12';
      if (casesHint) casesHint.textContent = 'Planning path: enter the cases you need now (may be under 48). This does not meet the standard 48-case wholesale tier.';
    } else {
      // standard or unset — enforce 48 for standard wholesale (do not silently rewrite the typed value)
      casesInput.min = '48';
      casesInput.required = true;
      casesInput.placeholder = '48';
      if (casesHint) casesHint.textContent = 'Minimum 48 for standard wholesale.';
    }
  }

  pathRadios.forEach(function (radio) {
    radio.addEventListener('change', syncCasesConstraints);
  });
  syncCasesConstraints();

  function showError(msg) {
    if (!errorEl) return;
    if (!msg) { errorEl.hidden = true; errorEl.textContent = ''; return; }
    errorEl.hidden = false;
    errorEl.textContent = msg;
  }

  function groupChecked(name) {
    return form.querySelectorAll('[data-wholesale-required-group="' + name + '"]:checked').length > 0;
  }

  function validateStep(n) {
    showError('');
    var step = form.querySelector('[data-wholesale-step="' + n + '"]');
    if (!step) return true;

    if (n === 3) {
      syncCasesConstraints();
      if (!selectedQuotePath()) {
        showError('Choose a quote path: standard wholesale (48+) or planning under 48.');
        return false;
      }
    }

    var required = step.querySelectorAll('input[required], select[required], textarea[required]');
    for (var i = 0; i < required.length; i++) {
      var el = required[i];
      if (el.type === 'radio') {
        var name = el.name;
        var radioChecked = false;
        form.querySelectorAll('input[type="radio"]').forEach(function (r) {
          if (r.name === name && r.checked) radioChecked = true;
        });
        if (!radioChecked) {
          el.focus();
          showError('Please complete the required fields.');
          return false;
        }
        continue;
      }
      if (typeof el.checkValidity === 'function' && !el.checkValidity()) {
        if (el.id === 'Wholesale-Cases' && selectedQuotePath() === 'standard') {
          showError('Standard wholesale requires at least 48 cases. Switch to the planning path if your volume is under 48.');
        }
        el.reportValidity();
        return false;
      }
      if (!String(el.value || '').trim()) {
        el.focus();
        showError('Please complete the required fields.');
        return false;
      }
    }
    if (n === 3) {
      if (!groupChecked('product')) { showError('Select at least one product of interest.'); return false; }
      if (!groupChecked('size')) { showError('Select at least one size.'); return false; }
      var cases = parseInt(casesInput && casesInput.value, 10);
      var path = selectedQuotePath();
      if (!cases || cases < 1) {
        showError('Enter how many cases you need.');
        if (casesInput) casesInput.focus();
        return false;
      }
      if (path === 'standard' && cases < 48) {
        showError('Standard wholesale requires at least 48 cases. Switch to the planning path if your volume is under 48.');
        if (casesInput) { casesInput.setCustomValidity('Minimum 48 cases for standard wholesale.'); casesInput.reportValidity(); casesInput.setCustomValidity(''); casesInput.focus(); }
        return false;
      }
    }
    return true;
  }

  function buildReview() {
    if (!reviewEl) return;
    var rows = [];
    form.querySelectorAll('[data-review-label]').forEach(function (el) {
      if (el.type === 'radio' && !el.checked) return;
      if (el.type === 'checkbox') return;
      var label = el.getAttribute('data-review-label');
      var val = (el.value || '').trim();
      rows.push([label, val || '—']);
    });
    var groups = {};
    form.querySelectorAll('[data-review-group]').forEach(function (el) {
      if (!el.checked) return;
      var g = el.getAttribute('data-review-group');
      (groups[g] = groups[g] || []).push(el.value);
    });
    Object.keys(groups).forEach(function (g) {
      rows.push([g, groups[g].join(', ')]);
    });
    var html = '<dl>';
    rows.forEach(function (pair) {
      html += '<dt>' + pair[0] + '</dt><dd>' + (pair[1] === '—' ? '<span class="wholesale-review__empty">—</span>' : escapeHtml(pair[1])) + '</dd>';
    });
    html += '</dl>';
    reviewEl.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function go(n) {
    current = Math.max(1, Math.min(total, n));
    steps.forEach(function (step) {
      var num = parseInt(step.getAttribute('data-wholesale-step'), 10);
      var on = num === current;
      step.hidden = !on;
      step.classList.toggle('is-active', on);
    });
    indicators.forEach(function (li) {
      var num = parseInt(li.getAttribute('data-step-indicator'), 10);
      li.classList.toggle('is-active', num === current);
      li.classList.toggle('is-done', num < current);
    });
    if (statusEl) statusEl.textContent = 'Step ' + current + ' of ' + total + ' — ' + (stepNames[current] || '');
    if (backBtn) backBtn.hidden = current === 1;
    if (nextBtn) nextBtn.hidden = current === total;
    if (submitBtn) submitBtn.hidden = current !== total;
    showError('');
    if (current === total) buildReview();
    if (wizard) wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (!validateStep(current)) return;
      go(current + 1);
    });
  }
  if (backBtn) {
    backBtn.addEventListener('click', function () { go(current - 1); });
  }

  form.addEventListener('submit', function (e) {
    if (current !== total) {
      e.preventDefault();
      if (validateStep(current)) go(current + 1);
      return;
    }
    for (var s = 1; s <= total - 1; s++) {
      if (!validateStep(s)) {
        e.preventDefault();
        go(s);
        return;
      }
    }
  });

  go(1);
})();


/* product-size-required */
  // Product form: require Size before add-to-cart; map options → variant id
  (function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('[data-product-variant-id]');
    var btn = form.querySelector('[data-add-to-cart]');
    var selects = form.querySelectorAll('[data-option-select]');

    function selectedOptions() {
      var opts = [];
      selects.forEach(function (sel) {
        opts.push(sel.value || null);
      });
      return opts;
    }

    function findVariant(opts) {
      if (opts.some(function (o) { return !o; })) return null;
      return (product.variants || []).find(function (v) {
        return opts.every(function (o, i) {
          return String(v['option' + (i + 1)]) === String(o);
        });
      }) || null;
    }

    function sync() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      if (!variant) {
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = 'Choose size to add';
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (btn) {
        if (variant.available === false) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = 'Sold out';
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.textContent = 'Add to cart';
        }
      }
      // Update URL ?variant= without reload
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    selects.forEach(function (sel) {
      // Ensure placeholder selected unless URL has variant
      var params = new URLSearchParams(window.location.search);
      var hasVariant = params.get('variant');
      if (!hasVariant && sel.getAttribute('data-size-select') !== null) {
        sel.selectedIndex = 0;
      }
      sel.addEventListener('change', sync);
    });

    form.addEventListener('submit', function (e) {
      var opts = selectedOptions();
      if (opts.some(function (o) { return !o; })) {
        e.preventDefault();
        var sizeSel = form.querySelector('[data-size-select]');
        if (sizeSel) sizeSel.focus();
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Choose size to add';
        }
      }
    });

    sync();
  })();


/* force-us-usd-market */
  // Prefer US market / USD presentment when shop still has AED primary (owner must rename shop country for full fix)
  (function () {
    try {
      if (window.sessionStorage && sessionStorage.getItem('hg_loc_us')) return;
      var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      if (active === 'USD') {
        if (window.sessionStorage) sessionStorage.setItem('hg_loc_us', '1');
        return;
      }
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization';
      form.style.display = 'none';
      function add(n, v) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i);
      }
      add('form_type', 'localization');
      add('_method', 'put');
      add('country_code', 'US');
      add('currency_code', 'USD');
      add('return_to', window.location.pathname + window.location.search);
      document.body.appendChild(form);
      if (window.sessionStorage) sessionStorage.setItem('hg_loc_us', '1');
      form.submit();
    } catch (e) {}
  })();


/* hg-mascot — site-wide HydroGlove helper: wave, slide, hover reactions, chat */
(function () {
  // Dual-select: mid-refactor hero-mascot + current hg-mascot
  var root =
    document.querySelector('[data-hg-mascot]') ||
    document.querySelector('[data-hero-mascot]');
  if (!root) return;

  if (root.classList.contains('hero-mascot') && !root.classList.contains('hg-mascot')) {
    root.classList.add('hg-mascot');
    root.classList.add(root.classList.contains('hero-mascot--docked') ? 'hg-mascot--docked' : 'hg-mascot--home');
  }
  root.querySelectorAll('[class*="hero-mascot"]').forEach(function (el) {
    el.className = el.className.replace(/hero-mascot/g, 'hg-mascot');
  });
  if (!root.hasAttribute('data-hg-mascot')) root.setAttribute('data-hg-mascot', '');

  var reduce = false;
  try {
    reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var tickleBtn =
    root.querySelector('[data-mascot-tickle]') ||
    root.querySelector('.hg-mascot__figure, .hero-mascot__figure');
  var openBtns = root.querySelectorAll('[data-mascot-open-chat], .hg-mascot__bubble, .hero-mascot__bubble');
  var chat =
    document.getElementById('hg-mascot-chat') ||
    document.querySelector('[data-mascot-chat]') ||
    root.querySelector('[data-mascot-chat]');
  var closeBtn = document.querySelector('[data-mascot-close-chat]');
  var messages = document.querySelector('[data-mascot-messages]');
  var form = document.querySelector('[data-mascot-form]');
  var input = document.querySelector('[data-mascot-input]');
  var chips = document.querySelector('[data-mascot-chips]');
  var heroMount = document.querySelector('[data-mascot-hero-mount]');
  var pageMode = root.getAttribute('data-mascot-mode') || (heroMount ? 'home' : 'docked');
  var isHomePage = pageMode === 'home' && !!heroMount;
  var docked = false;
  var introDone = false;
  var introRunning = false;
  var chatOpen = false;
  var lastRemountGreet = 0;

  openBtns.forEach(function (btn) {
    btn.style.pointerEvents = 'auto';
    btn.style.cursor = 'pointer';
    btn.setAttribute('data-mascot-open-chat', '');
    if (btn.tagName === 'P') {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    }
  });
  if (tickleBtn) {
    tickleBtn.style.pointerEvents = 'auto';
    tickleBtn.style.cursor = 'pointer';
  }

  // Keep long-press selection/context menus off the mascot while preserving taps.
  // The delayed preventDefault only runs after a long-press threshold; normal
  // touchstart → touchend still produces the native click/tickle action.
  var mascotPress = null;
  function mascotActionTarget(target) {
    if (!target || !target.closest) return null;
    var action = target.closest('[data-mascot-tickle], [data-mascot-open-chat], .hg-mascot__bubble, .hg-mascot__figure');
    return action && root.contains(action) ? action : null;
  }
  function clearMascotPress() {
    if (mascotPress && mascotPress.timer) window.clearTimeout(mascotPress.timer);
    mascotPress = null;
  }
  root.addEventListener('contextmenu', function (e) {
    if (mascotActionTarget(e.target)) e.preventDefault();
  });
  root.addEventListener('touchstart', function (e) {
    if (!e.cancelable || e.touches.length !== 1) return;
    var action = mascotActionTarget(e.target);
    if (!action) return;
    clearMascotPress();
    var touch = e.touches[0];
    var press = {
      id: touch.identifier,
      x: touch.clientX,
      y: touch.clientY,
      timer: null
    };
    press.timer = window.setTimeout(function () {
      if (mascotPress !== press) return;
      // Do not cancel a tap; suppress the long-press default only.
      if (e.cancelable) e.preventDefault();
    }, 500);
    mascotPress = press;
  }, { passive: false });
  root.addEventListener('touchmove', function (e) {
    if (!mascotPress) return;
    for (var i = 0; i < e.changedTouches.length; i++) {
      var touch = e.changedTouches[i];
      if (touch.identifier === mascotPress.id &&
          Math.hypot(touch.clientX - mascotPress.x, touch.clientY - mascotPress.y) > 10) {
        clearMascotPress();
        return;
      }
    }
  }, { passive: true });
  root.addEventListener('touchend', clearMascotPress, { passive: true });
  root.addEventListener('touchcancel', clearMascotPress, { passive: true });

  // Chat always on body (fixed side panel; avoid transform traps)
  if (chat && chat.parentElement !== document.body) {
    document.body.appendChild(chat);
  }

  function setState(state) {
    root.setAttribute('data-mascot-state', state);
    root.classList.toggle('is-waving', state === 'waving');
    root.classList.toggle(
      'is-greeting',
      state === 'greeting' || state === 'sliding' || state === 'settled' || state === 'idle'
    );
  }

  function kickWave() {
    void root.offsetWidth;
    setState('waving');
  }

  function softReGreet() {
    var now = Date.now();
    if (now - lastRemountGreet < 4000) return;
    lastRemountGreet = now;
    root.classList.add('is-greeting');
    if (!reduce) {
      kickWave();
      setTimeout(function () { setState('idle'); }, 900);
    } else {
      setState('idle');
    }
  }

  /** Move mascot to fixed bottom-right companion on body. */
  function dockToBody() {
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }
    root.classList.add('hg-mascot--docked');
    root.classList.remove('hg-mascot--home', 'hg-mascot--in-hero');
    root.setAttribute('data-mascot-mode', 'docked');
    root.classList.add('is-greeting');
    var st = root.getAttribute('data-mascot-state');
    if (st === 'boot' || st === 'waving' || st === 'sliding') {
      setState('idle');
    }
    docked = true;
  }

  /** Remount mascot into hero original position (home only). */
  function mountInHero(opts) {
    opts = opts || {};
    if (!heroMount || !isHomePage) return;
    if (chatOpen) return; // stay docked while chat panel is open
    if (root.parentElement !== heroMount) {
      heroMount.appendChild(root);
    }
    root.classList.add('hg-mascot--in-hero', 'hg-mascot--home');
    root.classList.remove('hg-mascot--docked');
    root.setAttribute('data-mascot-mode', 'home');
    docked = false;
    if (opts.softGreet && introDone) softReGreet();
    else if (!introRunning) {
      root.classList.add('is-greeting');
      if (!root.getAttribute('data-mascot-state') || root.getAttribute('data-mascot-state') === 'boot') {
        setState('idle');
      }
    }
  }

  function heroIsInView() {
    var hero = document.querySelector('[data-hero], .hero') || heroMount;
    if (!hero) return false;
    var rect = hero.getBoundingClientRect();
    // Treat hero as "in view" when a meaningful chunk is visible near top
    return rect.bottom > 140 && rect.top < window.innerHeight * 0.55;
  }

  function syncPlacementFromScroll() {
    if (!isHomePage || chatOpen) return;
    if (introRunning && !introDone) {
      // Allow early dock if user scrolls past hero mid-intro
      if (!heroIsInView()) {
        introDone = true;
        introRunning = false;
        setState('idle');
        dockToBody();
      }
      return;
    }
    if (heroIsInView()) {
      mountInHero({ softGreet: docked });
    } else {
      dockToBody();
    }
  }

  // Initial placement
  if (isHomePage) {
    mountInHero();
  } else {
    dockToBody();
  }

  function finishIntroInHero() {
    if (introDone) return;
    introDone = true;
    introRunning = false;
    setState('idle');
    // Stay in hero (original position) — do NOT auto-dock after intro
    if (isHomePage && !chatOpen && heroIsInView()) {
      mountInHero();
    } else if (isHomePage && !heroIsInView()) {
      dockToBody();
    }
  }

  // —— Intro sequence ——
  if (reduce) {
    setState('settled');
    setTimeout(function () {
      setState('idle');
      introDone = true;
      introRunning = false;
      if (!isHomePage) dockToBody();
      else if (!heroIsInView()) dockToBody();
      else mountInHero();
    }, 50);
  } else if (isHomePage && !docked) {
    introRunning = true;
    setState('boot');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(kickWave, 120);
        setTimeout(function () { if (!introDone) setState('greeting'); }, 920);
        setTimeout(function () { if (!introDone) setState('sliding'); }, 2040);
        setTimeout(function () { if (!introDone) setState('settled'); }, 2940);
        setTimeout(finishIntroInHero, 3300);
      });
    });
  } else {
    setState('greeting');
    requestAnimationFrame(function () {
      kickWave();
      setTimeout(function () { setState('idle'); }, 1200);
    });
    introDone = true;
  }

  // Home: observe hero visibility → dock / remount
  if (isHomePage) {
    var heroEl = document.querySelector('[data-hero], .hero') || heroMount;
    if (heroEl && 'IntersectionObserver' in window) {
      var heroIo = new IntersectionObserver(
        function () { syncPlacementFromScroll(); },
        { threshold: [0, 0.12, 0.28, 0.5], rootMargin: '-80px 0px -40% 0px' }
      );
      heroIo.observe(heroEl);
    }
    window.addEventListener('scroll', syncPlacementFromScroll, { passive: true });
    window.addEventListener('resize', syncPlacementFromScroll, { passive: true });
  }

  // —— Hover reactions: inflate/stretch/teeth + tickle/laugh on touch, no consecutive repeats ——
  var reactions = ['inflate', 'stretch', 'teeth', 'tickle', 'laugh', 'bounce', 'wink', 'wave', 'smile', 'explode', 'cry', 'hearts', 'blush', 'wiggle'];
  var idleGesturePool = ['inflate', 'stretch', 'teeth', 'bounce', 'wink', 'wave', 'smile', 'laugh'];
  var touchGestures = ['tickle', 'laugh']; // hover/touch: stronger tickle + laugh feedback
  var lastReact = '';
  var lastTouchReact = '';
  var reactTimer = null;
  var reactBusy = false;
  var touchComboTimer = null;

  function pickFromPool(pool, last) {
    var filtered = pool.filter(function (r) { return r !== last; });
    if (!filtered.length) filtered = pool.slice();
    return filtered[Math.floor(Math.random() * filtered.length)] || pool[0];
  }

  function pickReaction() {
    var pick = pickFromPool(reactions, lastReact);
    lastReact = pick;
    return pick;
  }

  function pickIdleGesture(tone) {
    // Prefer owner-requested idle set; lightly bias funny vs calm
    var funnyBias = ['laugh', 'bounce', 'wink', 'teeth', 'inflate'];
    var calmBias = ['stretch', 'smile', 'wave', 'inflate', 'wink', 'teeth'];
    var pool = tone === 'funny' ? funnyBias.concat(idleGesturePool) : calmBias.concat(idleGesturePool);
    if (reduce) return 'smile';
    var pick = pickFromPool(pool, lastReact);
    lastReact = pick;
    return pick;
  }

  function reactionDuration(name) {
    if (reduce) return 500;
    if (name === 'inflate' || name === 'stretch' || name === 'teeth') return 1050;
    if (name === 'tickle' || name === 'laugh') return 900;
    return 950;
  }

  function runReaction(forced) {
    if (reactBusy) return;
    var st = root.getAttribute('data-mascot-state');
    if (st === 'boot' || st === 'waving') return;
    var name = forced || (reduce ? 'smile' : pickReaction());
    lastReact = name;
    if (name === 'wave') {
      reactBusy = true;
      root.classList.add('is-reacting');
      kickWave();
      if (reactTimer) clearTimeout(reactTimer);
      reactTimer = setTimeout(function () {
        setState('idle');
        root.classList.remove('is-reacting');
        reactBusy = false;
      }, reduce ? 500 : 900);
      return;
    }
    reactBusy = true;
    root.classList.add('is-reacting');
    root.setAttribute('data-react', name);
    if (reactTimer) clearTimeout(reactTimer);
    reactTimer = setTimeout(function () {
      root.removeAttribute('data-react');
      root.classList.remove('is-reacting');
      reactBusy = false;
    }, reactionDuration(name));
  }

  /** Touch/hover: show a fresh joke, then play the tickle → laugh combo. */
  function runTouchFeedback() {
    if (typeof pickTouchJoke === 'function') setIdleBubble(pickTouchJoke());
    if (reduce) {
      runReaction('smile');
      return;
    }
    var first = lastTouchReact === 'tickle' ? 'laugh' : 'tickle';
    lastTouchReact = first;
    runReaction(first);
    if (touchComboTimer) clearTimeout(touchComboTimer);
    // Follow-up laugh/tickle so interaction feels punchy
    touchComboTimer = setTimeout(function () {
      if (chatOpen) return;
      var second = first === 'tickle' ? 'laugh' : 'tickle';
      lastTouchReact = second;
      runReaction(second);
    }, 780);
  }

  if (tickleBtn) {
    tickleBtn.addEventListener('mouseenter', runTouchFeedback);
    tickleBtn.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') return; // mouseenter already handles
      runTouchFeedback();
    });
    tickleBtn.addEventListener('focus', function () { runReaction('wink'); });
    tickleBtn.addEventListener('touchstart', function () { runTouchFeedback(); }, { passive: true });
    tickleBtn.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-mascot-open-chat]')) return;
      runTouchFeedback();
      openChat();
    });
  }

  // —— Chat (bottom-right side panel) ——
  var lastFocused = null;
  var kb = { products: [], links: {}, contact: {}, facts: {}, promo: {} };
  try {
    var kbEl = document.getElementById('hg-mascot-kb');
    if (kbEl) kb = JSON.parse(kbEl.textContent || '{}');
  } catch (e) {}

  function link(href, label) {
    if (!href) return label || '';
    var safe = String(href).replace(/"/g, '&quot;');
    return '<a href="' + safe + '">' + (label || href) + '</a>';
  }

  function mailto(email, label) {
    return link('mailto:' + email, label || email);
  }

  function tel(phone, label) {
    var digits = String(phone || '').replace(/[^\d+]/g, '');
    return link('tel:' + digits, label || phone);
  }

  function productById(id) {
    var list = kb.products || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id || (list[i].handle && list[i].handle.indexOf(id) !== -1)) return list[i];
    }
    return null;
  }

  function productLink(p) {
    if (!p) return '';
    var price = p.price ? ' — <strong>' + p.price + '</strong>' : '';
    return link(p.url, p.name || p.title) + price;
  }

  function contactBits() {
    var c = kb.contact || {};
    var email = c.email || 'info@thehydroglove.com';
    var phone = c.phone || '+1 (323) 205-7788';
    return mailto(email) + ' · ' + tel(phone);
  }

  function humanHandoffReply(reason) {
    var c = kb.contact || {};
    var email = c.email || 'info@thehydroglove.com';
    var phone = c.phone || '+1 (323) 205-7788';
    var contactUrl = (kb.links && kb.links.contact) || '/pages/contact';
    var why = reason
      ? ' For ' + reason + ', a human is the right fit.'
      : '';
    return 'Absolutely — I’ll hand you to the humans. They’ve got thumbs and everything.' + why +
      ' Reach Caltrades at ' + mailto(email) + ' or ' + tel(phone) +
      ', or hop over to ' + link(contactUrl, 'Contact') +
      ' / tap <strong>Talk to a human</strong>. Tell them HydroGlove sent you with a tiny wave.';
  }

  function wantsHuman(q) {
    return /human|real person|real people|talk to (a |someone|somebody|support|agent|rep)|speak to|live (agent|chat|person|support)|customer service|customer support|call (you|someone|us)|phone (support|number)|representative|agent please|help desk|operator/.test(q);
  }

  function needsHandoff(q) {
    return /order status|where.*(order|package|shipment)|track(ing)? (my )?(order|package)|cancel (my )?order|change (my )?order|payment (failed|issue|problem)|charged|chargeback|refund status|resale permit|tax (id|exempt)|legal|lawsuit|contract|liability|indemn|attorney|lawyer|hacked|password|account (hack|lock|secur)/.test(q);
  }

  function tokenize(q) {
    return (q || '').toLowerCase().replace(/[^a-z0-9%\s\-]/g, ' ').split(/\s+/).filter(function (t) {
      return t.length > 1 || /^(s|m|l)$/.test(t);
    });
  }

  function scoreFactCards(tokens) {
    var cards = kb.factCards || [];
    var scored = [];
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var score = 0;
      var tags = c.tags || [];
      for (var j = 0; j < tags.length; j++) {
        var tag = tags[j];
        for (var k = 0; k < tokens.length; k++) {
          if (tokens[k] === tag || (tag.length > 3 && tokens[k].indexOf(tag) === 0) || (tokens[k].length > 3 && tag.indexOf(tokens[k]) === 0)) {
            score += 2;
          }
        }
        // phrase presence in raw later handled by intents
      }
      if (score > 0) scored.push({ card: c, score: score });
    }
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored;
  }

  function composeCute(parts) {
    return parts.filter(Boolean).join(' ');
  }

  function replyFor(raw) {
    var q = (raw || '').toLowerCase().trim();
    var links = kb.links || {};
    var facts = kb.facts || {};
    var promo = kb.promo || {};
    var wholesale = kb.wholesale || {};
    var shipping = kb.shipping || {};
    var returns = kb.returns || {};
    var docs = kb.docs || {};
    var shop = links.shop || '/collections/all';
    var wholesaleUrl = links.wholesale || wholesale.formUrl || '/pages/request-wholesale-quote';
    var reports = links.reports || (docs.requestUrl) || '/pages/request-test-reports';
    var shippingPage = links.shipping || shipping.page || '/pages/shipping-returns';
    var about = links.about || '/pages/about';
    var contact = links.contact || '/pages/contact';
    var amazon = links.amazon || '';
    var cart = links.cart || '/cart';
    var privacy = links.privacy || '/policies/privacy-policy';
    var terms = links.terms || '/policies/terms-of-service';
    var black = productById('black') || { name: 'Black HydroGlove 6 mil', url: '/products/black-hydroglove-6mil', price: '$75.00', mil: '6' };
    var blue = productById('blue') || { name: 'Blue HydroGlove 4 mil', url: '/products/blue-hydroglove-4mil', price: '$70.00', mil: '4' };
    var pink = productById('pink') || { name: 'Pink HydroGlove 4 mil', url: '/products/pink-hydroglove-4mil', price: '$72.00', mil: '4' };
    var tokens = tokenize(q);

    if (!q) {
      return 'I heard a tiny squeak! Ask about sizes, colors, shipping, wholesale, FDA/ISO docs, returns, or say “talk to a human” — I’m stretchy and helpful.';
    }

    if (wantsHuman(q)) {
      return humanHandoffReply();
    }

    if (needsHandoff(q)) {
      return humanHandoffReply('orders, permits, payments, or legal questions');
    }

    // Intent flags (multi-intent friendly)
    var intent = {
      wholesale: /wholesale|bulk|moq|distributor|resell|48\s*cases|volume pricing|b2b|resale/.test(q),
      size: /size|sizing|s–xl|s-xl|\bs\b|\bm\b|\bl\b|xl|small|medium|large|fit/.test(q),
      returns: /return|refund|exchange|rma|damaged|wrong (item|order)/.test(q),
      shipping: /ship|delivery|freight|arrive|free ship|tracking|fulfill|how long|transit/.test(q) || (/warehouse|ontario|mission blvd/.test(q) && /ship|deliver|fulfill|from|process/.test(q)),
      docs: /fda|iso|cert|test report|document|docs|compliance|astm|en report|paperwork|puncture|chemical resist/.test(q),
      promo: /promo|discount|subscribe|10\s*%|coupon|code|sale|deal|first order/.test(q),
      price: /price|cost|how much|\$|pricing|expensive|cheap|list price/.test(q),
      pink: /\bpink\b/.test(q),
      blue: /\bblue\b/.test(q),
      black: /\bblack\b|6\s*mil|heavy.?duty|auto|mechanic|oil|paint|shop work/.test(q),
      material: /material|nitrile|latex|powder|allerg|what.*(made|made of)|composition|thickness|4\s*mil|mil\b/.test(q),
      recommend: /which|recommend|suggest|should i|best|pick|choose|difference|compare|glove\?/.test(q),
      order: /order|checkout|add to cart|buy|purchase|cart|how (do|to) (i )?order|payment method|pay with/.test(q),
      policy: /policy|policies|privacy|terms of service|terms|store policy|liability/.test(q),
      contact: /contact|email|phone|call us|address|office|los angeles|la\b|where are you|where.*(warehouse|located|based)|warehouse|ontario|mission blvd|hours/.test(q),
      about: /about|caltrades|who (are|is)|company|brand|story|made where|vietnam|china/.test(q),
      amazon: /amazon/.test(q),
      usecase: /kitchen|food|farm|hydropon|tattoo|beauty|salon|clean|clinic|health|dental|hospital/.test(q),
      hello: /^(hello|hi+|hey|howdy|good (morning|afternoon|evening))\b/.test(q),
      thanks: /thank|thx|ty\b/.test(q),
      joke: /joke|funny|make me laugh/.test(q),
      casePack: /case pack|how many (gloves|boxes)|1000|1,?000|per case/.test(q)
    };

    var parts = [];
    var matched = false;

    function add(s) { if (s) { parts.push(s); matched = true; } }

    if (intent.hello) {
      add('Hey hey! I’m HydroGlove — part helper, part rubber-ducky energy. What can I make easier today?');
    }
    if (intent.thanks) {
      add('Aww, you’re welcome! I’ll be right here if you need another soft suggestion — or a human handoff.');
    }
    if (intent.joke) {
      add('Why did the nitrile glove break up with the latex one? Too many allergies… and not enough stretch. (I’ll show myself to ' + link(shop, 'the shop') + '.)');
    }

    if (intent.wholesale) {
      add(composeCute([
        'Wholesale buddies, assemble!',
        wholesale.summary || 'Wholesale is a separate path from case shopping.',
        wholesale.standardMin || 'Standard wholesale quotes typically start at 48 cases',
        wholesale.regions ? '(' + wholesale.regions + ').' : '',
        wholesale.planning || '',
        wholesale.resalePermit ? 'Resale permits: ' + wholesale.resalePermit + '.' : '',
        link(wholesaleUrl, 'Request a wholesale quote') + ' — it does not add items to cart.',
        'Buying just a few cases? Use ' + link(shop, 'case shopping') + ' instead.',
        contactBits()
      ]));
    }

    if (intent.size) {
      add('We stretch from <strong>S to XL</strong>' +
        (facts.sizes ? ' — ' + facts.sizes : ' — size is required before add to cart') +
        '. Grab a color in ' + link(shop, 'the shop') +
        '. Between sizes? Sizing up is cozier for longer shifts.');
    }

    if (intent.casePack) {
      add('Case pack is always <strong>' + (facts.casePack || '10 boxes / 1,000 gloves') + '</strong> across Black, Blue, and Pink.');
    }

    if (intent.returns) {
      add('Returns stay gentle: ' +
        (returns.detail || facts.returns || 'Unopened cases in original packaging within 30 days; contact for authorization first.') +
        ' Full scoop: ' + link(shippingPage, 'Shipping & Returns') + '. ' + contactBits());
    }

    if (intent.shipping && !intent.returns) {
      var wh = (kb.contact && kb.contact.warehouse) || '4200 Mission Blvd, Ontario, CA 91761';
      add((shipping.headline ? '<strong>' + shipping.headline + '</strong>. ' : 'Good news with a little orange bow: <strong>free delivery nationwide</strong>. ') +
        (shipping.detail || facts.shipping || ('From our warehouse at ' + wh + '.')) +
        ' Details: ' + link(shippingPage, 'Shipping & Returns') + '.');
    }

    if (intent.docs) {
      add('We take the serious stuff seriously (while staying cute). ' +
        (docs.summary || 'FDA, ISO, ASTM/EN, and factory docs are available on request.') +
        ' ' + (docs.caveat || 'I won’t invent certificate numbers.') +
        ' Soft sell: ' + link(reports, 'request test reports') + '.');
    }

    if (intent.promo) {
      add((promo.subscribeFirstOrder || 'Subscribe and get 10% off your first order.') +
        ' Highlighted on ' + productLink(black) + ' and ' + productLink(blue) +
        '. ' + (promo.note || 'Pink stays at list price.') +
        ' Browse ' + link(shop, 'all gloves') + '.');
    }

    if (intent.price) {
      add('Case list pricing (10 boxes / 1,000 gloves): ' +
        productLink(black) + '; ' + productLink(blue) + '; ' + productLink(pink) +
        '. Black & Blue often show a subscribe <strong>10% first-order</strong> display price on the site; confirm at checkout. ' +
        'Wholesale volume pricing is quote-only via ' + link(wholesaleUrl, 'the wholesale form') + '.');
    }

    // Color / product specific — prefer explicit color over generic black regex
    if (intent.pink) {
      var pf = (pink.features || []).slice(0, 3).join('; ');
      add('Pink is our “spot me on the line” cutie — 4 mil, latex-free, powder-free' +
        (pf ? ' (' + pf + ')' : '') + '. Soft suggestion: ' + productLink(pink) + '.');
    }
    if (intent.blue) {
      add('Blue is the everyday high-five — 4 mil for kitchens, cleaning, farms, and trades. ' +
        productLink(blue) + (promo.subscribeFirstOrder ? ' (often shows the subscribe 10% first-order vibe).' : '.'));
    }
    if (intent.black && !intent.blue && !intent.pink) {
      add('Black is our thickest tough cookie — <strong>6 mil</strong> for auto, oil, paint, and shop days. ' +
        productLink(black) + '.');
    } else if (/\bblack\b/.test(q) && (intent.blue || intent.pink)) {
      add('Black (6 mil) sits next to them at ' + productLink(black) + '.');
    }

    if (intent.material && !intent.pink && !intent.blue && !(/\bblack\b/.test(q))) {
      add('We’re <strong>nitrile, latex-free, and powder-free</strong>. Black is 6 mil; Blue & Pink are 4 mil. Case pack: ' +
        (facts.casePack || '10 boxes / 1,000 gloves') +
        '. ' + (facts.foodSafe ? facts.foodSafe + '. ' : '') +
        'More brand story: ' + link(about, 'About') + '.');
    }

    if (intent.usecase && !intent.recommend) {
      var uses = (kb.useCases || []).join(' · ');
      add('HydroGlove shows up for: ' + (uses || 'auto, kitchen, healthcare, farming, beauty, cleaning') +
        '. Heavy messy work → ' + productLink(black) + '; everyday → ' + productLink(blue) + ' or ' + productLink(pink) + '.');
    }

    if (intent.recommend) {
      add('Tiny fitting-room monologue: heavy messy work → ' + productLink(black) +
        '. Everyday tasks → ' + productLink(blue) + ' or ' + productLink(pink) +
        '. Same case pack everywhere (' + (facts.casePack || '10 boxes / 1,000') + '). Or wander ' +
        link(shop, 'all gloves') + ' like a calm little parade.');
    }

    if (intent.order && !intent.wholesale) {
      add('Ordering is cozy: pick a glove in ' + link(shop, 'the shop') +
        ', choose <strong>size S–XL</strong> (required before add to cart), then checkout. Cart: ' +
        link(cart, 'your cart') + '. For 48+ cases / B2B, use ' + link(wholesaleUrl, 'wholesale quote') +
        ' instead of Add to cart. Mid-flow questions? ' + contactBits() + '.');
    }

    if (intent.policy) {
      add('Shipping & returns: ' + link(shippingPage, 'Shipping & Returns') +
        '. Privacy: ' + link(privacy, 'Privacy Policy') +
        '. Terms: ' + link(terms, 'Terms of Service') +
        '. For legal interpretation or custom contracts, please ' + link(contact, 'talk to a human') +
        ' — I’m the stretchy FAQ sidekick, not a lawyer.');
    }

    if (intent.contact) {
      var office = (kb.contact && kb.contact.office) || 'Los Angeles, CA 90028';
      var wh2 = (kb.contact && kb.contact.warehouse) || '4200 Mission Blvd, Ontario, CA 91761';
      add('Caltrades Inc. (HydroGlove) — ' + contactBits() +
        '. Warehouse: ' + wh2 + '. Office: ' + office +
        '. Or ' + link(contact, 'the contact page') + '.');
    }

    if (intent.about) {
      add('HydroGlove is by <strong>Caltrades Inc.</strong> — US-based team, factory-direct feel, fulfilled from Ontario, CA with an LA office. ' +
        (facts.production ? facts.production + '. ' : '') +
        link(about, 'About us') + ' has the story. Need a human? ' + contactBits() + '.');
    }

    if (intent.amazon) {
      if (amazon) {
        add('Yep — you can also find us on Amazon: ' + link(amazon, 'HydroGlove on Amazon') +
          '. Shopping here supports us directly too — ' + link(shop, 'browse the shop') + '.');
      } else {
        add('Amazon link isn’t loaded in my pocket right now — try ' + link(shop, 'our shop') +
          ' or ask the humans at ' + contactBits() + '.');
      }
    }

    if (matched) {
      // Deduplicate near-identical consecutive pushes; join with space
      var out = [];
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] && out.indexOf(parts[i]) === -1) out.push(parts[i]);
      }
      return out.join(' ');
    }

    // Retrieval fallback: compose from factCards + products
    var scored = scoreFactCards(tokens);
    if (scored.length && scored[0].score >= 2) {
      var bits = ['Hmm, let me stretch my knowledge base…'];
      for (var s = 0; s < Math.min(3, scored.length); s++) {
        if (scored[s].score >= 2) bits.push(scored[s].card.text);
      }
      bits.push('Products: ' + productLink(black) + '; ' + productLink(blue) + '; ' + productLink(pink) + '.');
      bits.push('More: ' + link(shippingPage, 'shipping/returns') + ' · ' +
        link(wholesaleUrl, 'wholesale') + ' · ' + link(reports, 'FDA/ISO docs') +
        ' · ' + link(contact, 'Contact') + '.');
      return bits.join(' ');
    }

    // Honest unknown — never invent
    return 'I don’t want to invent an answer I’m not sure about. Here’s what I *do* know from the site: ' +
      productLink(black) + '; ' + productLink(blue) + '; ' + productLink(pink) +
      '. Free nationwide shipping · sizes S–XL · ' + link(shippingPage, 'returns') + ' · ' +
      link(wholesaleUrl, 'wholesale') + ' · ' + link(reports, 'FDA/ISO docs') +
      '. For anything else (orders, permits, legal), ' + link(contact, 'Contact') +
      ' or ' + contactBits() + ' — or say “talk to a human”.';
  }

  function appendMsg(html, who) {
    if (!messages) return;
    var div = document.createElement('div');
    div.className = 'hg-mascot-chat__msg hg-mascot-chat__msg--' + who;
    div.innerHTML = '<p>' + html + '</p>';
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function openChat() {
    if (!chat) return;
    // Dock so panel + mascot sit in the corner together (chat parked on body)
    dockToBody();
    chatOpen = true;
    if (typeof pauseIdle === 'function') pauseIdle();
    root.classList.remove('hg-mascot--bubble-pop');
    lastFocused = document.activeElement;
    chat.hidden = false;
    root.classList.add('hg-mascot--chat-open');
    document.body.classList.add('hg-mascot-chat-open');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    try { window.dispatchEvent(new Event('resize')); } catch (e1) {}
    setTimeout(function () {
      try { window.dispatchEvent(new Event('resize')); } catch (e2) {}
      if (input) input.focus();
      else if (closeBtn) closeBtn.focus();
    }, 30);
  }

  function closeChat() {
    if (!chat) return;
    chat.hidden = true;
    chat.style.top = '';
    chat.style.bottom = '';
    chat.style.height = '';
    chat.style.maxHeight = '';
    chat.style.left = '';
    chat.style.right = '';
    chat.style.width = '';
    chat.classList.remove('hg-mascot-chat--kb');
    var panelEl = chat.querySelector('.hg-mascot-chat__panel');
    if (panelEl) {
      panelEl.style.height = '';
      panelEl.style.maxHeight = '';
    }
    chatOpen = false;
    if (typeof scheduleIdle === 'function') scheduleIdle();
    root.classList.remove('hg-mascot--chat-open');
    document.body.classList.remove('hg-mascot-chat-open');
    document.body.classList.remove('hg-mascot-chat-composing');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    try { window.dispatchEvent(new Event('resize')); } catch (e3) {}
    // If still on home and hero visible, remount to original hero position
    if (isHomePage && heroIsInView()) {
      mountInHero({ softGreet: true });
    } else if (isHomePage) {
      dockToBody();
    }
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus(); } catch (e) {}
    } else if (openBtns[0]) {
      openBtns[0].focus();
    }
  }

  function handleUserText(text) {
    var t = (text || '').trim();
    if (!t) return;
    appendMsg(t.replace(/</g, '&lt;').replace(/>/g, '&gt;'), 'user');
    setTimeout(function () {
      appendMsg(replyFor(t), 'bot');
      runReaction();
    }, reduce ? 120 : 380);
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openChat();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openChat();
      }
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeChat);

  if (chat) {
    chat.addEventListener('click', function (e) {
      if (e.target === chat) closeChat();
    });
  }

  // Human handoff control in chat header
  var humanBtn = document.querySelector('[data-mascot-human]');
  if (humanBtn) {
    humanBtn.addEventListener('click', function (e) {
      // Let default navigation/mailto work; also mirror a warm message if staying in chat
      if (humanBtn.getAttribute('data-mascot-human-inline') === 'true') {
        e.preventDefault();
        appendMsg(humanHandoffReply(), 'bot');
        runReaction();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && chat && !chat.hidden) {
      e.preventDefault();
      closeChat();
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = input ? input.value : '';
      if (input) input.value = '';
      handleUserText(val);
    });
  }

  if (chips) {
    chips.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-chip]');
      if (!btn) return;
      handleUserText(btn.getAttribute('data-chip') || btn.textContent);
    });
  }


  // —— Idle chatter: rotating glove jokes + light facts + cute gestures ——
  var bubbleTextEl =
    root.querySelector('.hg-mascot__bubble-text') ||
    root.querySelector('.hg-mascot__bubble span');
  var initialGreeting = 'How can I help you?';
  var initialGreetingShown = false;
  var defaultBubble = bubbleTextEl ? bubbleTextEl.textContent : initialGreeting;
  var idleTimer = null;
  var lastIdleTone = '';
  var lastBubbleLine = '';
  // ~50 brand-safe lines, alternating funny / lightly serious
  var idleLines = [
    { tone: 'funny', text: 'I tried to be a balloon. I popped under pressure.' },
    { tone: 'serious', text: 'Latex-free and powder-free for more comfortable hands.' },
    { tone: 'funny', text: 'Water fights are fun. Wet hands are not. I help with that.' },
    { tone: 'serious', text: 'Free delivery is available nationwide from Ontario, CA.' },
    { tone: 'funny', text: 'I live in a box of 100. Rent is cheap.' },
    { tone: 'serious', text: 'Sizes S through XL are available. Choose your size before checkout.' },
    { tone: 'funny', text: 'Messy job? Put me on. The job gets less messy for your hands.' },
    { tone: 'serious', text: 'Black is the thickest at 6 mil. Blue and Pink are 4 mil.' },
    { tone: 'funny', text: 'My textured fingertips help me hold on. I am clingy in a useful way.' },
    { tone: 'serious', text: 'Each case has 10 boxes, or 1,000 gloves.' },
    { tone: 'funny', text: 'I high-five engines, whisks, and paint cans. My schedule is full.' },
    { tone: 'serious', text: 'FDA, ISO, and test reports are available on request.' },
    { tone: 'funny', text: 'I am disposable, but my pep talk is reusable.' },
    { tone: 'serious', text: 'For larger orders, use the wholesale quote form.' },
    { tone: 'funny', text: 'I tried balloon art. It became a sad tube.' },
    { tone: 'serious', text: 'Unopened returns are accepted within 30 days with approval first.' },
    { tone: 'funny', text: 'I am soft armor for messy jobs.' },
    { tone: 'serious', text: 'Nitrile helps protect hands from oils and liquids without latex.' },
    { tone: 'funny', text: 'Lemons make lemonade. Grease calls for gloves.' },
    { tone: 'serious', text: 'Caltrades is a US-based team with a warehouse in Ontario, CA.' },
    { tone: 'funny', text: 'Pink is easy to spot. It is hard to lose and harder to ignore.' },
    { tone: 'serious', text: 'Our gloves are food-safe and have touchscreen-friendly fingertips.' },
    { tone: 'funny', text: 'No powder, no ghosting. I am here when you need me.' },
    { tone: 'serious', text: 'Most in-stock cases ship in 1 to 2 business days.' },
    { tone: 'funny', text: 'Black hides grease. That is one less thing to look at.' },
    { tone: 'serious', text: 'Shop cases online, or request a wholesale quote for larger orders.' },
    { tone: 'funny', text: 'I stretch before work. It is my glove workout.' },
    { tone: 'serious', text: 'Opened or used gloves usually cannot be returned for hygiene reasons.' },
    { tone: 'funny', text: 'I bring my own squeak to water balloon fights.' },
    { tone: 'serious', text: 'Need facility documents? Request the reports we have on file.' },
    { tone: 'funny', text: 'I set one simple boundary: mess stays off your hands.' },
    { tone: 'serious', text: 'Subscribe to save 10% on your first Black or Blue order.' },
    { tone: 'funny', text: 'Gloves on. Confidence up. That is my whole pep talk.' },
    { tone: 'serious', text: 'Questions? Email info@thehydroglove.com or call (323) 205-7788.' },
    { tone: 'funny', text: 'I handle one hand at a time, but I handle mess very well.' },
    { tone: 'serious', text: 'Choose Black 6 mil for heavier messes, or Blue and Pink 4 mil for everyday work.' },
    { tone: 'funny', text: 'I dream of bubble baths. Then I remember I am not a real hand.' },
    { tone: 'serious', text: 'We share only certification documents that are on file.' },
    { tone: 'funny', text: 'Tickle me and I giggle. I am a very friendly glove.' },
    { tone: 'serious', text: 'After the wholesale form, email your resale permit if you have one.' },
    { tone: 'funny', text: "Gloves on means your brain can say, 'We have got this.'" },
    { tone: 'serious', text: 'Our office is in Los Angeles. Fulfillment ships from Ontario, CA.' },
    { tone: 'funny', text: 'I tried stand-up comedy. Five thumbs showed up. Tough crowd.' },
    { tone: 'serious', text: "Tap me anytime, or say 'talk to a human' in chat." },
    { tone: 'funny', text: 'Warning: I may make messy work feel easier.' },
    { tone: 'serious', text: 'For a damaged shipment, send a photo and email us within 5 business days.' },
    { tone: 'funny', text: 'I stretch when I need to. I never stretch the truth.' },
    { tone: 'serious', text: 'Black, Blue, and Pink all come in the same case size.' },
    { tone: 'funny', text: 'If gloves could blush, Pink would blush first.' },
    { tone: 'serious', text: 'I am ready for shops, kitchens, clinics, farms, beauty, and cleaning.' }
  ];

  function showInitialGreeting() {
    if (initialGreetingShown || !bubbleTextEl) return;
    bubbleTextEl.textContent = initialGreeting;
    initialGreetingShown = true;
  }

  // One greeting per page load; idle jokes take over after the intro settles.
  showInitialGreeting();

  function setIdleBubble(text) {
    if (!bubbleTextEl || chatOpen) return;
    bubbleTextEl.textContent = text;
    root.classList.add('hg-mascot--bubble-pop');
    if (window.__hgBubblePopTimer) clearTimeout(window.__hgBubblePopTimer);
    window.__hgBubblePopTimer = setTimeout(function () {
      root.classList.remove('hg-mascot--bubble-pop');
    }, 420);
  }

  function pickTouchJoke() {
    var jokes = idleLines.filter(function (line) { return line.tone === 'funny'; });
    if (!jokes.length) jokes = idleLines;
    var choices = jokes.filter(function (line) { return line.text !== lastBubbleLine; });
    if (!choices.length) choices = jokes;
    var line = choices[Math.floor(Math.random() * choices.length)] || jokes[0];
    lastBubbleLine = line.text;
    return line.text;
  }

  function pickIdleLine() {
    // Randomize within the opposite tone so idle chatter alternates funny/factual.
    var choices = idleLines.filter(function (line) {
      return line.text !== lastBubbleLine && (!lastIdleTone || line.tone !== lastIdleTone);
    });
    if (!choices.length) {
      choices = idleLines.filter(function (line) { return line.text !== lastBubbleLine; });
    }
    if (!choices.length) choices = idleLines;
    var line = choices[Math.floor(Math.random() * choices.length)] || idleLines[0];
    lastBubbleLine = line.text;
    lastIdleTone = line.tone;
    return line;
  }

  function runIdleBeat() {
    if (chatOpen || document.hidden || !introDone) return;
    if (root.classList.contains('hg-mascot--tucked') && window.innerWidth < 900) {
      // Still rotate quietly on tucked mobile, shorter presence
    }
    var line = pickIdleLine();
    setIdleBubble(line.text);
    runReaction(pickIdleGesture(line.tone));
  }

  function scheduleIdle() {
    if (idleTimer) clearTimeout(idleTimer);
    if (chatOpen) return;
    // More often: inflate / stretch / teeth / bounce / wink / wave
    var base = reduce ? 14000 : 5200;
    var jitter = reduce ? 4000 : 4200;
    idleTimer = setTimeout(function () {
      runIdleBeat();
      scheduleIdle();
    }, base + Math.floor(Math.random() * jitter));
  }

  function pauseIdle() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = null;
  }

  // Start after intro settles
  setTimeout(function () {
    if (!chatOpen) scheduleIdle();
  }, reduce ? 2000 : 4200);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pauseIdle();
    else if (!chatOpen) scheduleIdle();
  });

  document.addEventListener('keydown', function (e) {
    if (!chat || chat.hidden || e.key !== 'Tab') return;
    var focusables = chat.querySelectorAll('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
    focusables = Array.prototype.filter.call(focusables, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();


/* Responsive readability helpers — keyboard-safe wholesale nav + mascot CTA clearance */
(function () {
  'use strict';

  var rootStyle = document.documentElement.style;

  function detectStickyShopBars() {
    var visibleSticky = false;
    document.querySelectorAll(
      '.mobile-sticky-cta, .sticky-cta-bar, .hg-sticky-order, [data-sticky-atc], .product-sticky-bar'
    ).forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) return;
      var r = el.getBoundingClientRect();
      if (r.height < 8) return;
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        if (r.bottom >= window.innerHeight - 8 || r.top >= window.innerHeight - r.height - 8) {
          visibleSticky = true;
        }
      }
    });
    document.body.classList.toggle('hg-has-sticky-cta', visibleSticky);
    rootStyle.setProperty('--hg-chat-bottom-extra', visibleSticky ? '3.75rem' : '0px');
  }

  function clearChatVvPin(chat) {
    if (!chat) return;
    chat.style.top = '';
    chat.style.bottom = '';
    chat.style.height = '';
    chat.style.maxHeight = '';
    chat.style.left = '';
    chat.style.right = '';
    chat.style.width = '';
    chat.classList.remove('hg-mascot-chat--kb');
    var panel = chat.querySelector('.hg-mascot-chat__panel');
    if (panel) {
      panel.style.height = '';
      panel.style.maxHeight = '';
    }
  }

  function stickyChatExtraPx(kbOpen) {
    if (kbOpen) return 0; // keyboard already clears bottom chrome
    if (!document.body.classList.contains('hg-has-sticky-cta')) return 0;
    var raw = (getComputedStyle(document.documentElement).getPropertyValue('--hg-chat-bottom-extra') || '').trim();
    if (!raw) return 60;
    var n = parseFloat(raw);
    if (!isFinite(n) || n <= 0) return 60;
    if (/rem$/i.test(raw)) return n * 16;
    return n;
  }

  function setKbOffset() {
    var vv = window.visualViewport;
    var chat = document.getElementById('hg-mascot-chat');
    if (!vv) {
      rootStyle.setProperty('--hg-vv-kb', '0px');
      rootStyle.setProperty('--hg-vv-height', window.innerHeight + 'px');
      rootStyle.setProperty('--hg-vv-offset-top', '0px');
      detectStickyShopBars();
      if (chat && chat.hidden) clearChatVvPin(chat);
      return;
    }
    // Keyboard / Safari chrome occluding the layout viewport bottom
    var occluded = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    rootStyle.setProperty('--hg-vv-kb', occluded + 'px');
    rootStyle.setProperty('--hg-vv-height', Math.max(240, vv.height) + 'px');
    rootStyle.setProperty('--hg-vv-offset-top', Math.max(0, vv.offsetTop) + 'px');
    detectStickyShopBars();

    if (!chat || chat.hidden) {
      clearChatVvPin(chat);
      return;
    }

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
      clearChatVvPin(chat);
      return;
    }

    // Pin the chat shell to the *visual* viewport so composer stays above the
    // soft keyboard even when Safari scrolls offsetTop (layout-fixed bottom fails).
    var pad = 8;
    var kbOpen = occluded > 72 || document.body.classList.contains('hg-mascot-chat-composing');
    var extra = stickyChatExtraPx(kbOpen);
    var top = Math.max(0, vv.offsetTop) + pad;
    var available = Math.max(220, vv.height - pad * 2 - extra);

    chat.style.top = top + 'px';
    chat.style.bottom = 'auto';
    chat.style.left = 'max(0.45rem, env(safe-area-inset-left, 0px))';
    chat.style.right = 'max(0.45rem, env(safe-area-inset-right, 0px))';
    chat.style.width = 'auto';
    chat.style.height = available + 'px';
    chat.style.maxHeight = available + 'px';
    chat.classList.toggle('hg-mascot-chat--kb', kbOpen);

    var panel = chat.querySelector('.hg-mascot-chat__panel');
    if (panel) {
      panel.style.height = '100%';
      panel.style.maxHeight = '100%';
    }

    // Keep the focused composer row in view inside the panel
    var active = document.activeElement;
    if (active && chat.contains(active) && /INPUT|TEXTAREA/.test(active.tagName)) {
      var form = chat.querySelector('.hg-mascot-chat__form');
      if (form) {
        try {
          form.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } catch (err) { /* ignore */ }
      }
    }
  }

  setKbOffset();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setKbOffset);
    window.visualViewport.addEventListener('scroll', setKbOffset);
  }
  window.addEventListener('resize', setKbOffset);
  window.addEventListener('orientationchange', function () {
    setTimeout(setKbOffset, 100);
    setTimeout(setKbOffset, 400);
  });

  // Mascot chat composer: re-pin on focus so Send sits above soft keyboard
  function isMascotComposer(el) {
    return !!(el && el.closest && el.closest('#hg-mascot-chat') &&
      /INPUT|TEXTAREA/.test(el.tagName));
  }
  document.addEventListener('focusin', function (e) {
    if (!isMascotComposer(e.target)) return;
    document.body.classList.add('hg-mascot-chat-composing');
    setKbOffset();
    setTimeout(setKbOffset, 50);
    setTimeout(setKbOffset, 280); // iOS keyboard animation
  });
  document.addEventListener('focusout', function (e) {
    if (!isMascotComposer(e.target)) return;
    // Delay: relatedTarget may move within chat; keyboard dismiss is async
    setTimeout(function () {
      var a = document.activeElement;
      if (isMascotComposer(a)) return;
      document.body.classList.remove('hg-mascot-chat-composing');
      setKbOffset();
      setTimeout(setKbOffset, 280);
    }, 30);
  });

  // When focusing inputs in wholesale wizard, keep sticky nav above keyboard
  var wholesaleForm = document.getElementById('WholesaleForm');
  if (wholesaleForm) {
    wholesaleForm.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !/INPUT|SELECT|TEXTAREA/.test(t.tagName)) return;
      setTimeout(function () {
        setKbOffset();
        try {
          t.scrollIntoView({ block: 'center', behavior: 'smooth' });
        } catch (err) {
          t.scrollIntoView(true);
        }
      }, 120);
    });
  }

  // Mascot: tuck / hide when overlapping primary actionable controls
  var mascot = document.querySelector('[data-hg-mascot], .hg-mascot--docked, .hg-mascot');
  if (!mascot) return;

  var CTA_SELECTOR = [
    '.btn--primary',
    '[data-add-to-cart]',
    '[data-wholesale-next]',
    '[data-wholesale-back]',
    '[data-wholesale-submit]',
    '.wholesale-nav .btn',
    '.product-form .btn',
    '.cart__checkout .btn',
    '[name="checkout"]',
    '.header-cart',
    '.menu-toggle',
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    '[id*="cookie"]',
    '.footer-col a',
    '.footer-bottom a'
  ].join(',');

  function rectsOverlap(a, b, pad) {
    pad = pad || 8;
    return !(
      a.right < b.left - pad ||
      a.left > b.right + pad ||
      a.bottom < b.top - pad ||
      a.top > b.bottom + pad
    );
  }

  function updateMascotClearance() {
    if (!mascot || mascot.classList.contains('hg-mascot--chat-open')) {
      mascot.classList.remove('hg-mascot--tucked', 'hg-mascot--away');
      return;
    }
    // Form / product / cart pages: keep compact FAB behavior on phones
    if (window.innerWidth < 900 && /template-(page-request-wholesale-quote|page-contact|page-request-test-reports|cart|product)/.test(document.body.className)) {
      mascot.classList.add('hg-mascot--tucked');
      return;
    }
    // Only care when docked / fixed
    var cs = window.getComputedStyle(mascot);
    if (cs.position !== 'fixed' && !mascot.classList.contains('hg-mascot--docked')) {
      mascot.classList.remove('hg-mascot--tucked', 'hg-mascot--away');
      return;
    }

    // Temporarily clear tuck to measure natural box
    mascot.classList.remove('hg-mascot--tucked', 'hg-mascot--away');
    var mr = mascot.getBoundingClientRect();
    if (mr.width < 1 || mr.height < 1) return;

    var hits = 0;
    var strongHit = false;
    var nodes = document.querySelectorAll(CTA_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.closest && el.closest('.hg-mascot, .hg-mascot-chat')) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) continue;
      // Only consider in-viewport elements
      if (r.bottom < 0 || r.top > window.innerHeight) continue;
      if (rectsOverlap(mr, r, 12)) {
        hits++;
        var tag = (el.tagName || '').toLowerCase();
        var cls = (el.className || '').toString();
        if (
          tag === 'button' ||
          el.getAttribute('data-add-to-cart') != null ||
          el.getAttribute('data-wholesale-next') != null ||
          el.getAttribute('data-wholesale-submit') != null ||
          /btn--primary|checkout/.test(cls)
        ) {
          strongHit = true;
        }
      }
    }

    if (strongHit || hits >= 2) {
      mascot.classList.add('hg-mascot--tucked');
    }
    // Near page bottom / footer links: tuck harder
    var footer = document.querySelector('.site-footer');
    if (footer) {
      var fr = footer.getBoundingClientRect();
      if (fr.top < window.innerHeight - 40 && rectsOverlap(mr, fr, 24)) {
        mascot.classList.add('hg-mascot--tucked');
      }
    }
  }

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      updateMascotClearance();
    });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('focusin', schedule);
  setTimeout(updateMascotClearance, 400);
  setInterval(updateMascotClearance, 1500);
})();
